import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-ctrl-item-requested",
  templateUrl: "./ctrl-item-requested.component.html",
  styleUrls: ["./ctrl-item-requested.component.css"],
})
export class CtrlItemRequestedComponent implements OnChanges {
  @Input() survey: any;
  @Input() item: any;
  @Output() itemChanged = new EventEmitter();

  constructor() {}

  ngOnChanges(): void {
    if (this.item.type == "SUCCESSFACTOR" || this.item.type == "INDICATOR") {
      if (!this.item.hasOwnProperty("requested")) {
        this.item["requested"] = {};
      }
      for (let subindicator of ["E", "I", "P", "C"]) {
        if (!this.item["requested"].hasOwnProperty(subindicator)) {
          this.item["requested"][subindicator] = false;
        }
      }
    }
    if (this.item.type == "QUESTION") {
      if (!this.item.hasOwnProperty("requested")) {
        this.item["requested"] = false;
      }
    }
  }

  public onChangeSuccessfactor(subindicator: any) {
    if (this.item.type == "SUCCESSFACTOR") {
      for (let subitem of this.item["items"]) {
        if (!subitem.hasOwnProperty("requested")) {
          subitem["requested"] = {};
        }
        for (let subindicator of ["E", "I", "P", "C"]) {
          if (!subitem["requested"].hasOwnProperty(subindicator)) {
            subitem["requested"][subindicator] = false;
          }
        }
        subitem["requested"][subindicator] =
          this.item["requested"][subindicator];
      }
    }
    this.itemChanged.emit({ item: this.item });
  }

  public onChangeRequested() {
    this.itemChanged.emit({ item: this.item });
  }
}
